import React, { useState } from 'react';
import {
    Create, SimpleForm, TextInput, SelectInput, Toolbar, NumberInput, required, useTranslate,
    usePermissions, useRecordContext
} from 'react-admin';
import GetTaskButton from './Buttons/GetTask';
import BarcodeScannerButton from './Buttons/BarcodeScanner';
import { Box, Typography, Grid, Card } from '@mui/material';
// import { makeStyles } from '@mui/material';
import {
    CodStatoUsoChoices,
    ReverseChoices, CausaliChoices
} from '../objects';
import ValidateAndSaveButton from './Buttons/ValidateAndSave';

// const useStyles = makeStyles({
//     inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
//     sx={{ display: 'none' }}: { display: 'none' },
//     inlineWide: { display: 'inline-flex', marginRight: '1rem', width: '351px' }
// });

function DeviceCreate() {
    const [formValues, setFormValues] = useState({});

    const translate = useTranslate();
    const { permissions } = usePermissions();

    const DeviceToolbar = () => {
        const record = useRecordContext();
        return (
            <Toolbar >
                <ValidateAndSaveButton
                    label="Salva"
                    redirect="list"
                    submitOnEnter={false}
                    variant="flat"
                    rdata={record}
                />
            </Toolbar>
        )
    };

    //Used for Devices to allow Cordova users to enter manually
    //a SN and serch by hitting enter
    const handleKeyPress = () => {
        var element = document.getElementById('serial_number_tim');
        if (!element.dataset.addedevent) {
            element.addEventListener('change', function () {
                document.getElementById('GetDeviceButton').click();
            });
            element.dataset.addedevent = true;
        }
    }

    const validateWorkrequestid = (value, allValues) => {
        if (!value) {
            return translate('tim.devices.mandatory');
        }
        else {
            //clear fields if the workrequestid changed manually
            var extRef = document.getElementById('workrequestid');
            if (extRef) {
                if (extRef.dataset.isSuccess === 'false') {
                    return translate('tim.devices.ivalid_gettask');
                }
                else if (extRef && extRef.dataset.gettaskres && extRef.dataset.gettaskres !== extRef.value) {
                    extRef.dataset.gettaskres = "";
                    clearInputValue(document.getElementById('impianto'), '');
                    clearInputValue(document.getElementById('codice_impresa_name'), '');
                    clearInputValue(document.getElementById('tipo_task'), '');
                    clearInputValue(document.getElementById('wr_prodotti'), '');
                    clearInputValue(document.getElementById('cod_proj'), '');
                    clearInputValue(document.getElementById('client_type'), '');
                    clearInputValue(document.getElementById('resource_id'), '');
                    clearInputValue(document.getElementById('equivalenza_prod_applicabile'), '');

                    return translate('tim.devices.get_task_mandatori');
                }
                else if (!extRef.dataset.gettaskres) {
                    return  translate('tim.devices.get_task_mandatori');
                }
            }
        }
        
        return undefined;
    }

    const validateWR = [validateWorkrequestid, required()]

    const validateSerialNumber = (value, allValues) => {
        if (!value) {
            return translate('tim.devices.mandatory');
        }
        else {
            var sn = document.getElementById('serial_number_tim');
            if (sn && (!sn.dataset.getdeviceres || (sn.dataset.getdeviceres && sn.dataset.getdeviceres !== sn.value))) {
                return translate('tim.devices.sn_search_mandatory_1');
            }
        }

        return undefined;
    }

    const validateSerial = [validateSerialNumber, required()]

    const CodTerrSapList = () => {
        var user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
        var res = [];
        if (user_cod_terr_sap) {
            var x = JSON.parse(user_cod_terr_sap);
            x.forEach(function (c) {
                res.push({ id: c, name: c });
            })
        }
        return <SelectInput source="cod_terr_sap" choices={res} sx={{ width: '14rem'}}/>;
    }


    const clearInputValue = (element, value) => {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
        element.dispatchEvent(new Event('input', { bubbles: true }));
    }

    const Aside = () => {
            return (
                <Box sx={{ width: '500px', ml: '1em' }}>
                    <Card sx={{ padding: '1em' }}>
                        <Typography variant="h6" sx={{ marginBottom: '1em' }}>Dati di dettaglio</Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.impianto')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {formValues?.impianto}
                                </Typography>
                            </ Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.codice_impresa_name')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {formValues?.codice_impresa_name}
                                </Typography>
                            </ Grid>
                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.cod_proj')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2"  >
                                    {formValues?.cod_proj}
                                </Typography>
                            </ Grid>

                            <Grid item xs={6}>
                                <Typography sx={{ fontSize: 14 }} color="textSecondary" variant="body1">
                                    {translate('resources.devices.fields.causale.descrizione')}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" >
                                    {formValues && formValues['causale.codice'] !== undefined ? CausaliChoices.find(c => c.id == formValues['causale.codice'])?.name : undefined}
                                </Typography>
                            </ Grid>
                        </Grid>
                    </Card>
                </Box>
            );
    };

    const handleValueChange = e => {
        const { name, value } = e.target;
        setFormValues(formValues => ({
            ...formValues,
            ...{ [name]: value }
        }));
    }

    return (
        <Create aside={<Aside />}>
            <SimpleForm toolbar={<DeviceToolbar />} >
                <Box sx={{ display: 'inline-flex' }}>
                    <TextInput source="serial_number_tim" sx={{ width: '14rem'}} onKeyUp={handleKeyPress} validate={validateSerial} />
                    <BarcodeScannerButton />
                </Box>
                <TextInput source="serial_number_forn" />
                <Box sx={{ display: 'inline-flex' }}>
                    <NumberInput source="workrequestid" sx={{ width: '14rem'}} validate={validateWR}/>
                    <GetTaskButton />
                </Box>
                <TextInput source="externalrefid" sx={{ display: 'none' }} />
                <TextInput source="mac_address" sx={{ width: '14rem'}} />
                {/* {permissions === 'tecnico' ? <TextInput source="impianto_regman" disabled/> : <TextInput source="impianto_regman" } */}

                <CodTerrSapList />
                <TextInput source="num_consegna" sx={{ width: '14rem'}} />
                <SelectInput source="cod_stato_uso.codice" choices={CodStatoUsoChoices} sx={{ width: '14rem'}} />
                <SelectInput source="reverse.codice" choices={ReverseChoices} sx={{ width: '14rem'}} />
                <TextInput source="causale.codice" sx={{ display: 'none' }} onChange={handleValueChange}/>

                <TextInput source="impianto" sx={{ display: 'none' }} onChange={handleValueChange} />
                <TextInput source="codice_impresa_name" sx={{ display: 'none' }} onChange={handleValueChange}/>
                <TextInput source="tipo_task" sx={{ display: 'none' }} />
                <TextInput source="wr_prodotti" sx={{ display: 'none' }} />
                <TextInput source="cod_proj" sx={{ display: 'none' }} onChange={handleValueChange}/>
                <TextInput source="client_type" sx={{ display: 'none' }} />
                <TextInput source="resource_id" sx={{ display: 'none' }} />
                <TextInput source="data_completamento_wr" sx={{ display: 'none' }} />
                <TextInput source="check_NMU" sx={{ display: 'none' }} />
                <TextInput source="codice_isp" sx={{ display: 'none' }} />
                <TextInput source="flag_olo" sx={{ display: 'none' }} />
                <TextInput source="tsys" sx={{ display: 'none' }} />
                <TextInput source="descrizione_impresa" sx={{ display: 'none' }} />
                <TextInput source="lista_NMU" sx={{ display: 'none' }} />
                <TextInput source="area" sx={{ display: 'none' }} />
                <TextInput source="progetto_con_scarico" sx={{ display: 'none' }} />
                <TextInput source="tipo_nmu" sx={{ display: 'none' }} />
                <TextInput source="codice_riscontro" sx={{ display: 'none' }} />
                <TextInput source="post_delivery" sx={{ display: 'none' }} />
                <TextInput source="equivalenza_prod_applicabile" sx={{ display: 'none' }} />
            </SimpleForm>
        </Create>
    );
}


export default DeviceCreate;